// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__pMQ16","element":"styles_element__YsdE_","load":"styles_load__on_Gm"};